import { Box } from "@mui/material";
// import { Sidebar } from "./components/Sidebar";
import { Sidebar } from "./components/Sidebar";
import { Redirect, Route, Switch } from "react-router";
import { Model } from "./views/Model";
import { AllModels } from "./views/AllModels";
import { SearchModels } from "./views/SearchModels";
import { SchemaCreateWizard } from "./components/SchemaCreateWizard";
import { ResizableContainer } from "../../../../shell/components/ResizeableContainer";
export const SchemaApp = () => {
  return <Box
  //TODO: Move body level styles to actual body of the application once all apps are migrated to new shell
  sx={{
    color: "text.primary",
    backgroundColor: "background.paper",
    height: "100%",
    display: "flex",
    "*": {
      boxSizing: "border-box"
    }
  }} data-sentry-element="Box" data-sentry-component="SchemaApp" data-sentry-source-file="index.tsx">
      <ResizableContainer id="schemaNav" defaultWidth={220} minWidth={220} maxWidth={360} data-sentry-element="ResizableContainer" data-sentry-source-file="index.tsx">
        <Sidebar data-sentry-element="Sidebar" data-sentry-source-file="index.tsx" />
      </ResizableContainer>
      <Switch data-sentry-element="Switch" data-sentry-source-file="index.tsx">
        <Route exact path="/schema" render={() => <AllModels />} data-sentry-element="Route" data-sentry-source-file="index.tsx" />
        <Route path="/schema/search" render={() => <SearchModels />} data-sentry-element="Route" data-sentry-source-file="index.tsx" />
        <Route exact path="/schema/start" render={() => <SchemaCreateWizard />} data-sentry-element="Route" data-sentry-source-file="index.tsx" />
        <Redirect from="/schema/new" to="/schema" data-sentry-element="Redirect" data-sentry-source-file="index.tsx" />
        <Route path="/schema/:id" render={() => <Model />} data-sentry-element="Route" data-sentry-source-file="index.tsx" />
      </Switch>
    </Box>;
};